// extracted by mini-css-extract-plugin
module.exports = {"main-component":"updatePrd_main-component__FSwaS"};